import { FC, SVGProps } from 'react';

export const Person3Icon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 10 10" fill="none" {...props}>
    <ellipse cx="5.00065" cy="7.29183" rx="2.91667" ry="1.45833" fill="white" />
    <circle cx="5.00065" cy="2.91667" r="1.66667" fill="white" />
  </svg>
);
